/*
 * @Author: Dong
 * @Date: 2022-04-29 13:39:42
 * @LastEditors: zhang lin
 * @LastEditTime: 2023-02-28 16:20:49
 */
import React, { useEffect } from 'react';
import { MessageDescriptor } from 'react-intl';
import { Form, Input } from 'sup-ui';
import styles from './Form.less';
import { useSelector } from 'react-redux';
import { reducerStates } from 'root/store/types';
import messages from './messages';
import { useIntl } from 'react-intl';

interface propsType {
  name: string;
  dataSource: { name: string; label: MessageDescriptor; type: any; rules?: any[]; placeholder?: string }[];
  form: any;
  version: string;
}

const formItemLayout = {
  labelCol: {
    sm: { span: 8 },
  },
  wrapperCol: {
    sm: { span: 16 },
  },
};

const FormComponent = (props: propsType) => {
  const intl = useIntl();

  const { form, name, dataSource } = props;

  const { getFieldDecorator } = form;
  const { nodeFormData } = useSelector((state: reducerStates) => state.nodeConfig);

  // 收集上传列表中的个性化表单配置
  useEffect(() => {
    if (!window.ndeConfigForms) {
      window.ndeConfigForms = {};
    }
    window.ndeConfigForms[name] = form;
    return () => {
      delete window.nodeForms[name];
    };
  }, []);

  return (
    <div>
      <div className={styles.division}>
        <h3 className={styles.text}>{intl.formatMessage(messages.config)}</h3>
      </div>
      <Form className={styles.form} {...formItemLayout}>
        {dataSource?.map((item) => {
          const rules: any[] = item.rules
            ? item.rules.map((rule) => {
                return { ...rule, message: rule.message };
              })
            : [];
          const { placeholder } = item;
          return (
            <Form.Item key={item.name} label={item.label}>
              {getFieldDecorator(item.name, {
                initialValue: nodeFormData?.[name]?.[item.name],
                rules: rules,
              })(<Input size="small" placeholder={placeholder} />)}
            </Form.Item>
          );
        })}
      </Form>
    </div>
  );
};

export default Form.create()(FormComponent);
